import { message } from "antd";
import internalApi from "../axios/internalApi";

export const saveTopDeals = async (payload) => {
  try {
    return await internalApi.post(
      { server: "api/v1/", path: "admin/top-deals" },
      payload
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getTopDealsByCity = async (city) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/top-deals?city=${city}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getTopDealsCities = async () => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: "admin/top-deals/cities",
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteTopDealsByCity = async (city) => {
  try {
    return await internalApi.delete({
      server: "api/v1/",
      path: `admin/top-deals?city=${city}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
